module.exports = __webpack_public_path__ + "static/media/Stellar Ace King Headboard - 180 cm.6134361f.jpg";